import { useShowComponentByRoutes } from "hooks/useShowComponentByRoutes";
import "./index.scss";
import { INTERNAL_PATHS } from "routes/paths";
import { Button } from "components/UI/atoms/button";
import { Input } from "components/UI/atoms";
import { useSubscribeEmail } from "./utils/useSubscribeEmail";
import { EmailSubscriptionFeedback } from "components/UI/molecules/email-subscription-feedback";

const ROUTES_TO_SHOW = [
  INTERNAL_PATHS.HOME,
  INTERNAL_PATHS.FTC_DISCLOSURE,
  INTERNAL_PATHS.SHOP_LOCAL,
  INTERNAL_PATHS.HOW_IT_WORKS,
  INTERNAL_PATHS.REFERRAL_PROGRAM,
  INTERNAL_PATHS.CART,
  INTERNAL_PATHS.ORDERS,
  INTERNAL_PATHS.BRAND_DETAILS
];

export const EmailSubscribe = () => {
  const { isVisible } = useShowComponentByRoutes({ routes: ROUTES_TO_SHOW });
  const { handleSubmit, errorMessage, successMessage, clearErrorMessage } =
    useSubscribeEmail();

  if (!isVisible) return <></>;

  return (
    <div className="email-subscribe-container">
      <div className="email-title">
        <h2>
          Stay in the know.
          <br />
          Get top discounts delivered straight to your inbox.
        </h2>
      </div>
      <div className="form-container">
        <form noValidate onSubmit={handleSubmit}>
          <Input
            customClassName="input-email"
            id="newsletter"
            name="email"
            type="email"
            placeholder="Enter your email"
            required
          />
          <Button customClassName="join-button" type="submit">
            SUBSCRIBE
          </Button>
        </form>
        {!!errorMessage && !successMessage && (
          <EmailSubscriptionFeedback
            message={errorMessage}
            onDismiss={clearErrorMessage}
            isErrorFeedback
          />
        )}
        {!!successMessage && !errorMessage && (
          <EmailSubscriptionFeedback
            message={successMessage}
            isErrorFeedback={false}
          />
        )}
      </div>
    </div>
  );
};
